import React, { forwardRef, useState } from "react";
import styles from "./CheckrBackgroundCheckView.module.css";
import FormDatePicker from "components/FormDatePicker";
import { format } from "date-fns";

const CheckrBackgroundCheckView = forwardRef(
  ({ data = {}, onChange, disabled = false }, ref) => {
    const handleSetDate = (value) => {
      if (value) {
        const [month, day, year] = value.split("/");
        const utcDate = new Date(`${year}-${month}-${day}T12:00:00.000Z`);
        data.reportCompletedOn = utcDate.toISOString();
      } else {
        data.reportCompletedOn = value;
      }

      onChange(data);
    };

    const normalizeDate = (dateValue) => {
      if (!dateValue) return "";

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        return dateValue;
      }

      if (dateValue.includes("Z") || dateValue.includes("T")) {
        const date = new Date(dateValue);
        return format(date, "MM/dd/yyyy");
      }

      return dateValue;
    };

    return (
      <>
        <div className={styles.container}>
          <div className={styles.testRow}>
            <label>Date of Report Completed:</label>
            <div className={styles.testItem2}>
              <div>
                <FormDatePicker
                  dateString={normalizeDate(data.reportCompletedOn)}
                  setDate={(value) => handleSetDate(value)}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default CheckrBackgroundCheckView;
